import AppContent from '../app-components/AppContent';

export default () => {
    return (
        // this needs to be updated with the application-specific component
        <AppContent></AppContent>
    )
}